export const SET_DATA_ROWS_CAMBIO_ADICIONAL =
  'cambio&Adicional/SET_DATA_ROWS_CAMBIO_ADICIONAL';
export const FETCH_DATA_CAMBIO_ADICIONAL =
  'cambio&Adicional/FETCH_DATA_CAMBIO_ADICIONAL';
export const GET_DATA_ROWS_CAMBIO_ADICIONAL =
  'cambio&Adicional/GET_DATA_ROWS_CAMBIO_ADICIONAL';
